export const APP = {
  Network: process.env.VUE_APP_NETWORK || '1'
};
